import {
    Badge,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {DataGrid} from "@mui/x-data-grid";

const DataSelector = ({label, data, valueKey, labelKey, forView, value, onChange, disabled, error}) => {
    const [checked, setChecked] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])

    const toggleChecked = () => {
        setChecked(!checked)
        setSelectedRows([])
    }

    const toggleAll = () => {
        if (selectedRows.length === data?.length) {
            setSelectedRows([])
            return
        }
        setSelectedRows(data?.map(item => item?.[valueKey]))
    }

    const handleChange = id => {
        if (selectedRows.includes(id)) {
            setSelectedRows(prev => ([...prev.filter(item => item !== id)]))
            return
        }
        setSelectedRows(prev => ([...prev, id]))
    }

    const save = () => {
        onChange(selectedRows)
        setChecked(!checked)
        setSelectedRows([])
    }

    const columns = [
        {
            field: 'select',
            headerName: <Checkbox disabled={forView || disabled} onChange={toggleAll}
                                  checked={selectedRows.length === data?.length}/>,
            width: 90,
            sortable: false,
            renderCell: params => {
                return <Checkbox onChange={() => handleChange(params.row?.[valueKey])} disabled={forView || disabled}
                                 checked={selectedRows.includes(params.row?.[valueKey])}/>
            }
        },
        {field: valueKey, headerName: 'Id', width: 90},
        {field: labelKey, headerName: 'Single SourceReason', width: 700},

    ]

    useEffect(() => {
        if (value?.length) {
            setSelectedRows(value)
        }
    }, [checked]);

    return (
        <>
            <Dialog open={checked} onClose={toggleChecked} maxWidth={800}>
                <DialogTitle>{label}</DialogTitle>
                <DialogContent>
                    <Box sx={{height: 400, width: 800}}>
                        <DataGrid
                            columns={columns}
                            rows={data}/>
                    </Box>
                </DialogContent>
                <DialogActions>
                    {(!forView && !disabled) && (
                        <Button variant='contained' onClick={save}
                                type='button'>Save</Button>
                    )}
                    <Button variant="outlined" onClick={toggleChecked}
                            sx={{color: 'gray', borderColor: '#D3D3D3'}}>Cancel</Button>
                </DialogActions>
            </Dialog>
            <Box display="flex" flexDirection="column">
                <Badge badgeContent={value?.length} color="error" style={{width: '100%'}}>
                    <Button onClick={() => setChecked(true)} variant="contained" color="primary" fullWidth>
                        {label}
                    </Button>
                </Badge>
                {error &&
                    <FormHelperText
                        sx={{color: '#d32f2f'}}>{error?.message || 'This field is required'}</FormHelperText>}
            </Box>
        </>
    )
}

export default DataSelector